module.exports = [["city","Stadt"],["landscape","Land"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/LandScapeSituation.json
// module id = 222
// module chunks = 0